var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5962",
    "data-name": "Path 5962",
    d: "M14.5,2H3.5A1.5,1.5,0,0,0,2,3.5v11A1.5,1.5,0,0,0,3.5,16h11A1.5,1.5,0,0,0,16,14.5V3.5A1.5,1.5,0,0,0,14.5,2ZM3.5,3h11a.5.5,0,0,1,.5.5V6.78L9.5,11.81,6.84,9.145a.5.5,0,0,0-.685,0L3,11.9V3.5A.5.5,0,0,1,3.5,3Zm11,12H3.5a.5.5,0,0,1-.5-.5V13.225l3.5-3.04L8.81,12.5a1,1,0,0,0,1.38.03L15,8.135V14.5A.5.5,0,0,1,14.5,15Zm-4-7a2,2,0,1,0-2-2A2,2,0,0,0,10.5,8Zm0-3a1,1,0,1,1-1,1A1,1,0,0,1,10.5,5Z",
    transform: "translate(-2 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image_icon.0c2e1743633370a0175aaaaa2cf87326.svg";
export { ForwardRef as ReactComponent };